const actions = {
  GET_SCHEDULES_REQUEST: "GET_SCHEDULES_REQUEST",
  GET_SCHEDULES_SUCCESS: "GET_SCHEDULES_SUCCESS",

  GET_SCHEDULES_TWO_WAY_REQUEST: "GET_SCHEDULES_TWO_WAY_REQUEST",
  GET_SCHEDULES_TWO_WAY_SUCCESS: "GET_SCHEDULES_TWO_WAY_SUCCESS",

  SCHEDULES_LOADER: "SCHEDULES_LOADER",
  SET_SCHEDULES_ID: "SET_SCHEDULES_ID",
  SET_SCHEDULES_TWO_WAY_ID: "SET_SCHEDULES_TWO_WAY_ID",

  SET_UNLOCK_SCHEDULES_PAGE: "SET_UNLOCK_SCHEDULES_PAGE",

  GET_SCHEDULE_STOPS_REQUEST: "GET_SCHEDULE_STOPS_REQUEST",
  GET_SCHEDULE_STOPS_SUCCESS: "GET_SCHEDULE_STOPS_SUCCESS",

  SET_OPEN_SCHEDULE_INFO_MODAL: "SET_OPEN_SCHEDULE_INFO_MODAL",

  SCHEDULE_STOPS_LOADING: "SCHEDULE_STOPS_LOADING",

  SET_OPEN_CHOOSE_TWOWAY_SCHEDULE_MODAL:
    "SET_OPEN_CHOOSE_TWOWAY_SCHEDULE_MODAL",

  GET_REFUND_TICKET_SCHEDULES_REQUEST: "GET_REFUND_TICKET_SCHEDULES_REQUEST",
  GET_REFUND_TICKET_SCHEDULES_SUCCESS: "GET_REFUND_TICKET_SCHEDULES_SUCCESS",

  getSchedules: (token, companyId, from, to, date) => {
    return (dispatch) => {
      dispatch({
        type: actions.GET_SCHEDULES_REQUEST,
        token,
        companyId,
        from,
        to,
        date,
      });
    };
  },

  getSchedulesTwoWay: (token, companyId, from, to, date) => {
    return (dispatch) => {
      dispatch({
        type: actions.GET_SCHEDULES_TWO_WAY_REQUEST,
        token,
        companyId,
        from,
        to,
        date,
      });
    };
  },

  setSchedulesId: (value) => {
    return (dispatch) => {
      dispatch({
        type: actions.SET_SCHEDULES_ID,
        value,
      });
    };
  },

  setSchedulesTwoWayId: (value) => {
    return (dispatch) => {
      dispatch({
        type: actions.SET_SCHEDULES_TWO_WAY_ID,
        value,
      });
    };
  },

  setUnlockSchedulesPage: (value) => {
    return (dispatch) => {
      dispatch({
        type: actions.SET_UNLOCK_SCHEDULES_PAGE,
        value,
      });
    };
  },

  getScheduleStops: (token, companyId, kursId) => {
    return (dispatch) => {
      dispatch({
        type: actions.GET_SCHEDULE_STOPS_REQUEST,
        token,
        companyId,
        kursId,
      });
    };
  },

  setOpenScheduleInfoModal: (value) => {
    return (dispatch) => {
      dispatch({
        type: actions.SET_OPEN_SCHEDULE_INFO_MODAL,
        value,
      });
    };
  },

  setOpenChooseTwoWayScheduleModal: (value) => {
    return (dispatch) => {
      dispatch({
        type: actions.SET_OPEN_CHOOSE_TWOWAY_SCHEDULE_MODAL,
        value,
      });
    };
  },

  getRefundTicketSchedules: (token, companyId, from, to, date) => {
    return (dispatch) => {
      dispatch({
        type: actions.GET_REFUND_TICKET_SCHEDULES_REQUEST,
        token,
        companyId,
        from,
        to,
        date,
      });
    };
  },
};
export default actions;
